import React, { useState, useEffect } from "react";
import { ListWholesaler } from "./listofWholesaler";
import { IoIosArrowBack } from "react-icons/io";
import { MdOutlineDriveFolderUpload } from "react-icons/md";
import { FaArrowLeftLong } from "react-icons/fa6";
import { EditPersonalDetails } from "./editPersonalDetails";
import { EditOrderHistory } from "./editOrdersHistory/editOrder";
import { EditSubUsers } from "./editSubUsers/editSubUsers";
import { EditMedicine } from "./editMedicine/editMedicine";
import { WholesalerVerification } from "./WholesalerVerification";
import { useNavigate, useParams } from "react-router-dom";
import { axiosInstance } from "../../axiosInstance";

export function EditWholesaler() {
  const { id } = useParams();
  console.log(id);

  const [wholesalerDetails, setWholesalerDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const WholesalerUserName = localStorage.getItem("wholesaler_username");
  console.log("Wholesaler Username:", WholesalerUserName);

  const fetchWholesalers = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.get(`/admin/wholesaler-list/${id}`);
      console.log("✅ Wholesaler details response:", res.data);
      if (res.data.status === "success") {
        setWholesalerDetails(res.data.data || []);
      } else {
        setError("Failed to fetch Wholesaler data.");
      }
    } catch (err) {
      console.error("❌ Error fetching Wholesaler data:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWholesalers();
  }, []);

  // const [label, setLabel] = useState("File upload.pdf ");
  // function handleLabel(e) {
  //   setLabel(e.target.files[0]?.name || "File upload.pdf");

  // }
  const [content, setContent] = useState(<EditPersonalDetails id={id} />);
  const [activeEdit, setactiveEdit] = useState("personal");
  function handlePersonalDetails() {
    return <EditPersonalDetails id={id} />;
  }
  function handleOrderHistory() {
    return <EditOrderHistory />;
  }
  function handleSubUsers() {
    return <EditSubUsers WholesalerUserName={WholesalerUserName} id={id} />;
  }
  function handleMedicine() {
    return <EditMedicine />;
  }
  function handleWholesalerVerification() {
    return <WholesalerVerification id={id} />;
  }

  return (
    <div className="editWholesaler-container ">
      <div className="arrowNavigation">
        <FaArrowLeftLong
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/manage-wholesaler")}
        />
        <div>
          {wholesalerDetails?.wholesalers?.business_name || "Business Name"}
        </div>
        <div>Wholesaler ID: #{wholesalerDetails?.username || "N/A"}</div>
      </div>
      <div className="wholesalerMenu">
        <div
          onClick={() => {
            setContent(handlePersonalDetails);
            setactiveEdit("personal");
          }}
          className={`edit-menu ${
            activeEdit === "personal" ? "activeEdit" : ""
          }`}
        >
          Personal Details
        </div>
        {/* <div
          onClick={() => {
            setContent(handleWholesalerVerification);
            setactiveEdit("verification");
          }}
          className={`edit-menu ${
            activeEdit === "verification" ? "activeEdit" : ""
          }`}
        >
          Wholesaler Verification
        </div> */}
        <div
          onClick={() => {
            setContent(handleOrderHistory);
            setactiveEdit("orders");
          }}
          className={`edit-menu ${activeEdit === "orders" ? "activeEdit" : ""}`}
        >
          Orders History
        </div>
        <div
          onClick={() => {
            setContent(handleSubUsers);
            setactiveEdit("subusers");
          }}
          className={`edit-menu ${
            activeEdit === "subusers" ? "activeEdit" : ""
          }`}
        >
          Sub Users
        </div>
        <div
          onClick={() => {
            setContent(handleMedicine);
            setactiveEdit("medicine");
          }}
          className={`edit-menu ${
            activeEdit === "medicine" ? "activeEdit" : ""
          }`}
        >
          Medicine
        </div>
      </div>
      <div>{content}</div>
    </div>
  );
}
